//
//
//
//
//
//
//

export default {
    data () {
        return {
            show: true
        }
    },
    computed: {
        show_tip () {
            return this.has_new_result && this.show
        }
    },
    methods: {
        close () {
            this.show = false
        }
    },
    props: {
        data_status: {
            type: String,
            default: ''
        },
        has_new_result: {
            type: Boolean,
            default: false
        }
    }
}
